import { useEffect } from "react";
import { Col } from "react-bootstrap";
import Awareness from "./sections/Awareness";
import EthicsCounsellorCalendar from "./sections/EthicsCounsellorCalendar";
import LearningModules from "./sections/LearningModules";
import Documents from "./sections/Documents";
import Feedback from "../../components/feedbackNote/Feedback";
import Investigators from "./sections/Investigators";
import { isPermited } from "../../features/localStorage";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  GetLogsTracker,
  selectLogsTracker,
} from "../../features/login/logsTracker";
import { useParams } from "react-router-dom";
import LearningNew from "./LearningNew";

const Learning = () => {
  const dispatch = useAppDispatch();
  let params: any = useParams();
  let categoryId: any = params?.categoryId ? params?.categoryId : "";
  const LogsTracker = useAppSelector(selectLogsTracker);
  var moduleName = "Learning";
  useEffect(() => {
    async function fetchLogsTracker() {
      let sample = await dispatch(GetLogsTracker(moduleName));
    }
    fetchLogsTracker();
  }, []);

  return (
    <>
      <div className="mob">
        <p style={styles.learning}>Ethics Awareness</p>
      </div>
      <Feedback pageName="Learning And Awarness" />

      <LearningNew />
      <br />
      <LearningModules />
      {isPermited(6, 1) && <Investigators />}

      {categoryId && (
        <>
          <br />
          <Awareness />
          <Col lg={12}>
            <Documents />{" "}
          </Col>
        </>
      )}
      {/* {isPermited(2, 1) && <EthicsCounsellorCalendar />} */}
      {/* <CodeViolations /> */}
    </>
  );
};

const styles: any = {
  learning: {
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    fontWeight: "800",
    marginTop: "10px",
  },
};

export default Learning;
function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}
